import IconButton from '@mui/joy/IconButton';
import Snackbar, { type SnackbarProps } from '@mui/joy/Snackbar';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/Warning';
import { useToast } from './use-toast';

const defaultStartDecorator: Record<NonNullable<SnackbarProps['color']>, React.ReactNode> = {
  success: <CheckIcon />,
  danger: <ErrorIcon />,
  warning: <WarningIcon />,
  neutral: <InfoOutlinedIcon />,
  primary: <InfoOutlinedIcon />,
};

export const Toaster = () => {
  const { toasts, dismiss } = useToast();
  return (
    <>
      {toasts.map(function ({ id, title, description, startDecorator, ...props }) {
        return (
          <Snackbar
            key={id}
            {...props}
            color={props.severity}
            startDecorator={startDecorator ?? (props.severity ? defaultStartDecorator[props.severity] : undefined)}
            variant="soft"
            autoHideDuration={props.autoHideDuration ?? 5000}
            onClose={() => dismiss(id)}
            endDecorator={
              <IconButton onClick={() => dismiss(id)} sx={{ color: 'inherit', '--Icon-color': 'inherit' }}>
                <CloseIcon />
              </IconButton>
            }
          >
            <Stack>
              <Typography level="h4">{title}</Typography>
              {description && (
                <Typography level="body-sm" textColor="neutral.500">
                  {description}
                </Typography>
              )}
            </Stack>
          </Snackbar>
        );
      })}
    </>
  );
};
